import { defineMessages } from 'react-intl';

export default defineMessages({
  tituloGrafico: {
    id: 'PresupuestosGraficoCasosFinalizados.tituloGrafico',
    description: 'Título para el gráfico',
    defaultMessage: 'Casos finalizados',
  },
});
